export type IMaskCustomFields = IDCA.IGenericFunc;

export function _maskCustomFields(): void {
  $('[data-mask]')
    .not(
      '.code-postal-field, .phone-field, .poste-field, .percent-field, .decimal-field, .number-field, .money-field, .ignore-mask'
    )
    .each((_, input) => {
      const $input = $(input);
      const mask = $input.data('field-mask');
      const caseSensitive = $input.hasClass('case-sensitive');

      const options = {
        translation: caseSensitive
          ? {
              A: { pattern: /[A-Z]/ },
              N: { pattern: /[0-9]/ },
              a: { pattern: /[a-z]/ },
            }
          : {
              A: { pattern: /[A-Za-z]/ },
              N: { pattern: /[0-9]/ },
            },
      };

      if (mask) {
        ($input as any).mask(mask, options);
      }
    });
}
